import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'UI';

import {
  MainContainer,
} from './style';

interface VehicleExtraProps {
  onAddClick(): void
}

const VehicleExtra = ({
  onAddClick,
}: VehicleExtraProps): JSX.Element => (
  <MainContainer>
    <Button
      icon={<PlusOutlined size={14} />}
      onClick={onAddClick}
    >
      Cadastrar novo veículo
    </Button>
  </MainContainer>
);

export default VehicleExtra;
